import React, { useState, useEffect } from 'react';
import { Phone, Menu, X, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { restaurantInfo } from '../data/mockData';
import { trackCTAClick } from '../utils/analytics';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    trackCTAClick(`nav_${id}`);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-black/80'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-2 md:space-x-3 flex-shrink-0">
            <img
              src="https://customer-assets.emergentagent.com/job_cosmos-tacos/artifacts/m0583hsq_Le%20Cosmos%20Logo.jpg"
              alt="Le Cosmos Tacos"
              className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover border-2 border-[#D4AF37] shadow-lg"
            />
            <div className="text-lg md:text-xl lg:text-2xl font-bold whitespace-nowrap">
              <span className="text-white" style={{ fontFamily: 'Crimson Text, serif' }}>LE </span>
              <span className="text-[#D4AF37]" style={{ fontFamily: 'Crimson Text, serif' }}>COSMOS TACOS</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('accueil')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('avis')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              Avis
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              Contact
            </button>
            {/* Admin Link */}
            <Link
              to="/admin/login"
              className="flex items-center space-x-2 text-[#D4AF37] hover:text-[#FFD700] transition-colors duration-200 font-medium"
            >
              <Lock size={16} />
              <span>Admin</span>
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`}
              className="flex items-center space-x-2 bg-[#D4AF37] text-black px-6 py-3 rounded-md font-semibold hover:bg-[#C5A028] transition-all duration-200 hover:transform hover:-translate-y-0.5 hover:shadow-lg"
            >
              <Phone size={18} />
              <span>Appeler</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white hover:text-[#D4AF37] transition-colors"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-md py-6 space-y-4 border-t border-[#D4AF37]/20">
            <button
              onClick={() => scrollToSection('accueil')}
              className="block w-full text-left px-4 py-2 text-white hover:text-[#D4AF37] hover:bg-white/5 transition-colors"
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="block w-full text-left px-4 py-2 text-white hover:text-[#D4AF37] hover:bg-white/5 transition-colors"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-4 py-2 text-white hover:text-[#D4AF37] hover:bg-white/5 transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('avis')}
              className="block w-full text-left px-4 py-2 text-white hover:text-[#D4AF37] hover:bg-white/5 transition-colors"
            >
              Avis
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-2 text-white hover:text-[#D4AF37] hover:bg-white/5 transition-colors"
            >
              Contact
            </button>
            <Link
              to="/admin/login"
              className="flex items-center space-x-2 w-full text-left px-4 py-2 text-[#D4AF37] hover:text-[#FFD700] hover:bg-white/5 transition-colors"
            >
              <Lock size={16} />
              <span>Admin</span>
            </Link>
            <div className="px-4 pt-4">
              <a
                href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`}
                className="flex items-center justify-center space-x-2 bg-[#D4AF37] text-black px-6 py-3 rounded-md font-semibold hover:bg-[#C5A028] transition-colors w-full"
              >
                <Phone size={18} />
                <span>Appeler maintenant</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
